// this file gets conditionally included via gulp (check out gulpfile.js)
angular.module('webcomm')
    .run(['$rootScope', function($rootScope) {
        $rootScope.isDebuggingDisabled = true; // defaults to false
    }])
    .config(['$compileProvider', function ($compileProvider) {
        $compileProvider.debugInfoEnabled(false);
    }]);

